import type { FC } from 'react';
import { Skeleton } from '@chakra-ui/react';

/**
 * Skeleton component for a single recipe tile.
 * Mimics the structure of ProductTileRecipe with image and info section.
 */
export const RecipeTileSkeleton: FC = () => (
    <div className="flex h-full flex-col rounded-lg">
        <div className="recipe-card__image product-tile-image overflow-hidden rounded-t-lg">
            <div className="h-full w-full">
                <Skeleton
                    className="rounded-t-lg"
                    height={{ base: '165.5px', sm: '218px', md: '222px', lg: '301px', xl: '400px' }}
                    borderRadius="8px 8px 0 0"
                />
            </div>
        </div>
        {/* Info section skeleton */}
        <div className="product-tile-info flex flex-1 flex-col justify-between gap-3 rounded-b-lg bg-slt-grey-150 p-3">
            {/* Recipe name skeleton */}
            <Skeleton height="20px" width="80%" borderRadius="4px" />
            {/* Author skeleton */}
            <Skeleton height="14px" width="60%" borderRadius="4px" />
        </div>
    </div>
);

RecipeTileSkeleton.displayName = 'RecipeTileSkeleton';
